import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { FilterList } from "@mui/icons-material";
import { MdClose } from "react-icons/md";
import type { ReactNode } from "react";

const MODAL_PAPER_MOBILE =
  "!flex !flex-col !h-full !overflow-x-hidden !shadow-card app-card";
const MODAL_PAPER_DESKTOP =
  "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[90vh] !w-full !max-w-[calc(100vw-2rem)] !overflow-x-hidden sm:!max-w-3xl";

interface FilterDialogProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export const FilterDialog = ({
  open,
  onClose,
  children,
  footer,
  className = "",
}: FilterDialogProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      className={`filter-dialog ${className}`.trim()}
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      fullWidth
      maxWidth="md"
      scroll="paper"
      PaperProps={{
        className: isMobile ? MODAL_PAPER_MOBILE : MODAL_PAPER_DESKTOP,
      }}
    >
      <div className="relative flex min-h-0 flex-1 flex-col">
        <header className="flex shrink-0 items-center justify-between border-b border-gray-100 px-4 py-3 sm:px-6">
          <h2 className="m-0 flex items-center gap-2 text-base font-semibold text-gray-900">
            <FilterList sx={{ fontSize: 20 }} />
            Filtros
          </h2>
          <button
            type="button"
            aria-label="Fechar"
            onClick={onClose}
            className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-gray-400 transition hover:bg-gray-100 hover:text-gray-900"
          >
            <MdClose className="h-5 w-5" aria-hidden />
          </button>
        </header>

        <div
          className={`filter-dialog__body min-h-0 flex-1 overflow-y-auto px-4 pb-3 pt-4 sm:px-6 ${!isMobile ? "max-h-[70vh]" : ""}`}
        >
          {children}
        </div>

        {footer ? (
          <div className="filter-dialog__footer mt-auto flex shrink-0 flex-col-reverse gap-2 border-t border-gray-100 px-4 pb-5 pt-4 sm:flex-row sm:justify-end sm:px-6">
            {footer}
          </div>
        ) : null}
      </div>
    </Dialog>
  );
};
